import { createContext, useContext } from "react";
import { FormApi } from "./types";

const FormContext = createContext<FormApi<any>>(undefined as any);

export const FormProvider = FormContext.Provider;

export const useFormContext = () => {
  const formContext = useContext<FormApi<any>>(FormContext);

  if (!formContext) {
    throw new Error(
      `Form context is undefined. You are calling useFormContext() outside of a <Form> `
    );
  }

  return formContext as FormApi<any>;
};
